<template>
  <div class="equipments">
    <section class="section">
      <div class="container">
        <div class="columns is-vcentered">
          <div v-if="currentUserAccess('ProjectLogs',this.UserActions.CREATE, this.project_id)" class="column">
            <b-button class="button is-primary is-mobile" icon-left="plus-thick"
                      @click="addNewEquipmentLogClicked">
              {{ $t('equipments-logs.new-equipment-log-button') }}
            </b-button>
          </div>
        </div>
        <div class="columns">
          <div class="column is-full">
            <b-table class="equipments-logs-table" :data="equipmentsLogsData" :striped="true" :hoverable="true"
                     :mobile-cards="true" :loading="isLoading" :scrollable="true">
              <b-table-column field="date" :label="this.$t('equipments-logs.equipment-logdate-column')"
                              v-slot="props">
                {{ props.row.date }}
              </b-table-column>
              <b-table-column field="model" :label="this.$t('equipments-logs.equipment-model-column')"
                              v-slot="props">
                {{ props.row.model }}
              </b-table-column>
              <b-table-column field="provider" :label="this.$t('equipments-logs.equipment-provider-column')"
                              v-slot="props">
                {{ props.row.provider }}
              </b-table-column>
              <b-table-column field="quantity" :label="this.$t('equipments-logs.equipment-quantity-column')"
                              v-slot="props">
                {{ getFormattedQuantityValue(props.row.equipmentLog.quantity, props.row.unit) }}
              </b-table-column>
              <b-table-column field="total" :label="this.$t('equipments-logs.equipment-total-column')"
                              v-slot="props">
                {{ getFormattedQuantityValue(props.row.total, props.row.unit) }}
              </b-table-column>
              <b-table-column field="rest" :label="this.$t('equipments-logs.equipment-rest-column')"
                              v-slot="props">
                {{ getFormattedQuantityValue(props.row.rest, props.row.unit) }}
              </b-table-column>
              <b-table-column field="text" :label="this.$t('equipments-logs.equipment-text-column')"
                              v-slot="props">
                {{ props.row.equipmentLog.text }}
              </b-table-column>
              <b-table-column v-if="currentUserAccess('ProjectLogs',this.UserActions.DELETE,this.project_id)" :label="this.$t('equipments-logs.actions-column')" centered v-slot="props">
                <b-tooltip :label="$t('common.edit')" position="is-top">
                  <b-button class="button is-primary is-small mr-2"
                          @click="editEquipmentLogClicked(props.row.equipmentLog)" icon-left="pencil">
                  </b-button>
                </b-tooltip>
                <b-tooltip :label="$t('common.delete')" position="is-top">
                  <b-button class="button is-primary is-danger is-small"
                          @click="deleteEquipmentLogClicked(props.row.equipmentLog)" icon-left="delete">
                  </b-button>
                </b-tooltip>
              </b-table-column>
            </b-table>
          </div>
        </div>
      </div>
      <b-modal
          :width="640"
          v-model="isEquipmentLogModalActive"
          trap-focus
          :destroy-on-hide="true"
          aria-role="dialog"
          aria-modal>
        <template #default="props">
          <EquipmentLog v-bind:project_id="project_id" v-bind:equipments_data="equipmentsData" v-bind:log_data="selected_log" v-bind:selected_date="selected_date" @close="props.close"
                        @equipmentLogAdded="readEquipmentsLogsData" @equipmentLogUpdated="readEquipmentsLogsData"></EquipmentLog>
        </template>
      </b-modal>
    </section>
  </div>
</template>

<script>

import firebase from "firebase/app";
import EquipmentLog from "@/components/EquipmentLog";

export default {
  name: "EquipmentsLogs",
  components: {
    EquipmentLog
  },
  props: {
    'project_id': {
      type: String,
    },
    'selected_date': {}
  },
  watch: {
    selected_date: function () {
      this.dateSelectClicked(this.selected_date)
    }
  },
  data() {
    return {
      modelDate: new Date(),
      selectedUntilDate: new Date((new Date()).setHours(23, 59, 59, 0)),
      selectedFromDate: new Date((new Date()).setHours(0, 0, 0, 0)),
      equipmentsData: [],
      equipmentsLogsData: [],
      isLoading: false,
      isEquipmentLogModalActive: false,
      selected_log: {}
    }
  },
  methods: {
    readEquipmentsData: function () {
      this.equipmentsData = [];
      const functions = firebase.app().functions("europe-west3");
      const getEquipmentsFunction = functions.httpsCallable(this.getSubmitEndpoint());
      getEquipmentsFunction({action: "get_equipments", project_id: this.project_id, fill_meta: true})
          .then((result) => {
            console.log("equipments list result: ", result.data);
            if (result.data.equipments.length > 0) {
              result.data["equipments"].forEach((equipment) => {
                this.equipmentsData.push({
                  equipment: equipment,
                  model: equipment.model
                });
              });
            }
          })
          .catch((error) => {
            this.showError(error.message)
            console.log("Error getting equipments: ", error);
          });
    },
    readEquipmentsLogsData: function () {
      this.isEquipmentLogModalActive = false;
      this.isLoading = true;
      this.equipmentsLogsData = [];
      const functions = firebase.app().functions("europe-west3");
      const getEquipmentsLogsFunction = functions.httpsCallable(this.getSubmitEndpoint());
      const payloadData = {
        action: "get_logs",
        project_id: this.project_id,
        equipment_id: "*",
        fill_meta: true,
        filters: [['date', '>', this.selectedFromDate.toISOString()], ['date', '<', this.selectedUntilDate.toISOString()]]
      }
      getEquipmentsLogsFunction(payloadData)
          .then((result) => {
            console.log("equipments logs list result: ", result.data);
            if (result.data.equipmentslogs.length > 0) {
              result.data["equipmentslogs"].forEach((equipmentLog) => {
                this.equipmentsLogsData.push({
                  equipmentLog: equipmentLog,
                  total: equipmentLog.parent.logged_quantities,
                  rest: parseFloat(equipmentLog.meta.estimation.quantity) - parseFloat(equipmentLog.parent.logged_quantities),
                  unit: equipmentLog.parent.unit,
                  model: equipmentLog.parent.model,
                  provider: equipmentLog.parent.provider,
                  date: this.getFormattedDate(equipmentLog.date),
                  document_id: equipmentLog.document_id
                });
              });
            }
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            this.showError(error.message)
            console.log("Error getting equipment logs: ", error);
          });
    },
    deleteEquipmentLog: function (equipmentLog) {
      this.isLoading = true;
      const functions = firebase.app().functions("europe-west3");
      const deleteEquipmentLogFunction = functions.httpsCallable(this.getSubmitEndpoint());
      deleteEquipmentLogFunction({
        action: "delete_log",
        project_id: equipmentLog.project_id,
        equipment_id: equipmentLog.equipment_id,
        document_id: equipmentLog.document_id,
      }).then(() => {
        this.showSuccess(this.$t('messages.equipment-log-deleted'));
        this.readEquipmentsLogsData()
      }).catch((error) => {
        this.showError(error.message)
        console.log("Error deleting log: ", error);
      });
      this.isLoading = false;
    },
    /*
     UI Events
     */
    addNewEquipmentLogClicked: function () {
      this.readEquipmentsData();
      this.selected_log = {};
      this.selected_log.document_id = "new";
      this.isEquipmentLogModalActive = true;
    },
    editEquipmentLogClicked: function (equipmentLog) {
      this.readEquipmentsData();
      this.selected_log = equipmentLog;
      this.isEquipmentLogModalActive = true;
    },
    dateSelectClicked: function (date) {
      const fromDate = date.setHours(0, 0, 0, 0)
      const untilDate = date.setHours(23, 59, 59, 0)
      this.selectedFromDate = new Date(fromDate)
      this.selectedUntilDate = new Date(untilDate)
      this.readEquipmentsLogsData();
    },
    deleteEquipmentLogClicked: function (equipmentLog) {
      this.$buefy.dialog.confirm({
        title: this.$t('equipments-logs.delete-log-title').toString(),
        message: this.$t('equipments-logs.delete-log-message').toString(),
        confirmText: this.$t('equipments-logs.delete-log-button').toString(),
        cancelText: this.$t('common.cancel').toString(),
        type: 'is-danger',
        hasIcon: true,
        icon: 'delete',
        onConfirm: () => {
          this.deleteEquipmentLog(equipmentLog);
          this.readEquipmentsData();
        }
      });
    }
  },
  mounted() {
    this.readEquipmentsLogsData();
  }
};
</script>

<style scoped>
.equipments-logs-table {
  margin-top: 16px;
}
</style>
